import { render, staticRenderFns } from "./setProfit.vue?vue&type=template&id=b763a7ea&scoped=true&"
import script from "./setProfit.vue?vue&type=script&lang=js&"
export * from "./setProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b763a7ea",
  null
  
)

export default component.exports